import Cookies from 'universal-cookie';

const cookies = new Cookies();

export function favCheck(itemId, itemType) {
  itemId = String(itemId);

  //Get the cookie and store it into an array
  //ex: food=1,2,3&drink=4,5,6 becomes favList=["food=1,2,3", "drink=4,5,6"]
  if(cookies.get('shortlist') !== undefined) {
    const favList = cookies.get('shortlist').split('&');
    let drinkArray = [];
    let foodArray = [];
    let index = null;

    //Build the food and drink arrays from the cookie info
    //Firstly, get a substring from the cookie with the values from drinks and food
    //ex: favList=["food=1,2,3", "drink=4,5,6"] become "1,2,3" and "4,5,6"
    const foodString = favList[0].substring(favList[0].indexOf('=')+1);
    const drinkString = favList[1].substring(favList[1].indexOf('=')+1);

    //Then split the substring into an array we can work with
    //ex: "1,2,3" becomes foodArray=[1,2,3]
    if(foodString.length > 0) {
      foodArray = foodString.split(',');
    }
    if(drinkString.length > 0) {
      drinkArray = drinkString.split(',');
    }

    //Check if the selected item is already in array
    //Checking for food
    if(itemType === 'food') {
      index = foodArray.indexOf(itemId);
      return index !== -1;
    }
    //And for drinks
    else {
      index = drinkArray.indexOf(itemId);
      return index !== -1;
    }
  }
  // NO COOKIES WERE SET YET
  return false;
}



/** WEBPACK FOOTER **
 ** ./src/helpers/favCheck.js
 **/